import { render, staticRenderFns } from "./ChangeLogComponent.vue?vue&type=template&id=7b6bc240"
import script from "./ChangeLogComponent.vue?vue&type=script&lang=js"
export * from "./ChangeLogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports